import { useMutation } from '@tanstack/react-query';

import { PricingPlanCapFormSchemaValues } from 'src/features/pricingPlan/utils/formSchema';
import { PricingPlanCap } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/pricing/pricing-plan/:planId/pricing-plan-cap/`;

interface DTO extends PricingPlanCapFormSchemaValues {
    planId: string;
    parkingId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ planId, parkingId, ...data }: DTO): Promise<PricingPlanCap> => {
    return axios.post(formatResourcePath(RESOURCE, { planId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreatePricingPlanCap };
